/**
 *  @swagger
 *  definitions:
 *    Timestamps:
 *      type: object
 *      properties:
 *        updatedAt:
 *          description: date of the Model update
 *          type: string
 *          format: date-time
 *        createdAt:
 *          description: date of the Model create
 *          type: string
 *          format: date-time
 */
import type {
  $ModelParams as $Admin,
  $Associations as $AdminAssociations,
  $CreateParams as $AdminCreateParams,
  $QueryParams as $AdminQueryParams,
  $UpdateParams as $AdminUpdateParams,
  $UpsertParams as $AdminUpsertParams,
} from './Admin';

import type {
  $ModelParams as $AdminAccessToken,
  $Associations as $AdminAccessTokenAssociations,
  $CreateParams as $AdminAccessTokenCreateParams,
  $QueryParams as $AdminAccessTokenQueryParams,
  $UpdateParams as $AdminAccessTokenUpdateParams,
  $UpsertParams as $AdminAccessTokenUpsertParams,
} from './AdminAccessToken';

import type {
  $ModelParams as $AdminSocialUser,
  $Associations as $AdminSocialUserAssociations,
  $CreateParams as $AdminSocialUserCreateParams,
  $QueryParams as $AdminSocialUserQueryParams,
  $UpdateParams as $AdminSocialUserUpdateParams,
  $UpsertParams as $AdminSocialUserUpsertParams,
} from './AdminSocialUser';

import type {
  $ModelParams as $Advertisement,
  $Associations as $AdvertisementAssociations,
  $CreateParams as $AdvertisementCreateParams,
  $QueryParams as $AdvertisementQueryParams,
  $UpdateParams as $AdvertisementUpdateParams,
  $UpsertParams as $AdvertisementUpsertParams,
} from './Advertisement';

import type {
  $ModelParams as $Banner,
  $Associations as $BannerAssociations,
  $CreateParams as $BannerCreateParams,
  $QueryParams as $BannerQueryParams,
  $UpdateParams as $BannerUpdateParams,
  $UpsertParams as $BannerUpsertParams,
} from './Banner';

import type {
  $ModelParams as $BannerLocation,
  $Associations as $BannerLocationAssociations,
  $CreateParams as $BannerLocationCreateParams,
  $QueryParams as $BannerLocationQueryParams,
  $UpdateParams as $BannerLocationUpdateParams,
  $UpsertParams as $BannerLocationUpsertParams,
} from './BannerLocation';

import type {
  $ModelParams as $Championship,
  $Associations as $ChampionshipAssociations,
  $CreateParams as $ChampionshipCreateParams,
  $QueryParams as $ChampionshipQueryParams,
  $UpdateParams as $ChampionshipUpdateParams,
  $UpsertParams as $ChampionshipUpsertParams,
} from './Championship';

import type {
  $ModelParams as $ChampionshipAdmin,
  $Associations as $ChampionshipAdminAssociations,
  $CreateParams as $ChampionshipAdminCreateParams,
  $QueryParams as $ChampionshipAdminQueryParams,
  $UpdateParams as $ChampionshipAdminUpdateParams,
  $UpsertParams as $ChampionshipAdminUpsertParams,
} from './ChampionshipAdmin';

import type {
  $ModelParams as $ChampionshipAdminRequest,
  $Associations as $ChampionshipAdminRequestAssociations,
  $CreateParams as $ChampionshipAdminRequestCreateParams,
  $QueryParams as $ChampionshipAdminRequestQueryParams,
  $UpdateParams as $ChampionshipAdminRequestUpdateParams,
  $UpsertParams as $ChampionshipAdminRequestUpsertParams,
} from './ChampionshipAdminRequest';

import type {
  $ModelParams as $ChampionshipDocument,
  $Associations as $ChampionshipDocumentAssociations,
  $CreateParams as $ChampionshipDocumentCreateParams,
  $QueryParams as $ChampionshipDocumentQueryParams,
  $UpdateParams as $ChampionshipDocumentUpdateParams,
  $UpsertParams as $ChampionshipDocumentUpsertParams,
} from './ChampionshipDocument';

import type {
  $ModelParams as $ChampionshipRegatta,
  $Associations as $ChampionshipRegattaAssociations,
  $CreateParams as $ChampionshipRegattaCreateParams,
  $QueryParams as $ChampionshipRegattaQueryParams,
  $UpdateParams as $ChampionshipRegattaUpdateParams,
  $UpsertParams as $ChampionshipRegattaUpsertParams,
} from './ChampionshipRegatta';

import type {
  $ModelParams as $ChampionshipResultTable,
  $Associations as $ChampionshipResultTableAssociations,
  $CreateParams as $ChampionshipResultTableCreateParams,
  $QueryParams as $ChampionshipResultTableQueryParams,
  $UpdateParams as $ChampionshipResultTableUpdateParams,
  $UpsertParams as $ChampionshipResultTableUpsertParams,
} from './ChampionshipResultTable';

import type {
  $ModelParams as $ChampionshipResultTableEntry,
  $Associations as $ChampionshipResultTableEntryAssociations,
  $CreateParams as $ChampionshipResultTableEntryCreateParams,
  $QueryParams as $ChampionshipResultTableEntryQueryParams,
  $UpdateParams as $ChampionshipResultTableEntryUpdateParams,
  $UpsertParams as $ChampionshipResultTableEntryUpsertParams,
} from './ChampionshipResultTableEntry';

import type {
  $ModelParams as $ChampionshipResultTableRace,
  $Associations as $ChampionshipResultTableRaceAssociations,
  $CreateParams as $ChampionshipResultTableRaceCreateParams,
  $QueryParams as $ChampionshipResultTableRaceQueryParams,
  $UpdateParams as $ChampionshipResultTableRaceUpdateParams,
  $UpsertParams as $ChampionshipResultTableRaceUpsertParams,
} from './ChampionshipResultTableRace';

import type {
  $ModelParams as $ChampionshipResultTableRaceResult,
  $Associations as $ChampionshipResultTableRaceResultAssociations,
  $CreateParams as $ChampionshipResultTableRaceResultCreateParams,
  $QueryParams as $ChampionshipResultTableRaceResultQueryParams,
  $UpdateParams as $ChampionshipResultTableRaceResultUpdateParams,
  $UpsertParams as $ChampionshipResultTableRaceResultUpsertParams,
} from './ChampionshipResultTableRaceResult';

import type {
  $ModelParams as $ChampionshipSponsor,
  $Associations as $ChampionshipSponsorAssociations,
  $CreateParams as $ChampionshipSponsorCreateParams,
  $QueryParams as $ChampionshipSponsorQueryParams,
  $UpdateParams as $ChampionshipSponsorUpdateParams,
  $UpsertParams as $ChampionshipSponsorUpsertParams,
} from './ChampionshipSponsor';

import type {
  $ModelParams as $ChampionshipSubscription,
  $Associations as $ChampionshipSubscriptionAssociations,
  $CreateParams as $ChampionshipSubscriptionCreateParams,
  $QueryParams as $ChampionshipSubscriptionQueryParams,
  $UpdateParams as $ChampionshipSubscriptionUpdateParams,
  $UpsertParams as $ChampionshipSubscriptionUpsertParams,
} from './ChampionshipSubscription';

import type {
  $ModelParams as $Crewmember,
  $Associations as $CrewmemberAssociations,
  $CreateParams as $CrewmemberCreateParams,
  $QueryParams as $CrewmemberQueryParams,
  $UpdateParams as $CrewmemberUpdateParams,
  $UpsertParams as $CrewmemberUpsertParams,
} from './Crewmember';

import type {
  $ModelParams as $CrewmemberAccessToken,
  $Associations as $CrewmemberAccessTokenAssociations,
  $CreateParams as $CrewmemberAccessTokenCreateParams,
  $QueryParams as $CrewmemberAccessTokenQueryParams,
  $UpdateParams as $CrewmemberAccessTokenUpdateParams,
  $UpsertParams as $CrewmemberAccessTokenUpsertParams,
} from './CrewmemberAccessToken';

import type {
  $ModelParams as $CrewmemberRegattaNotification,
  $Associations as $CrewmemberRegattaNotificationAssociations,
  $CreateParams as $CrewmemberRegattaNotificationCreateParams,
  $QueryParams as $CrewmemberRegattaNotificationQueryParams,
  $UpdateParams as $CrewmemberRegattaNotificationUpdateParams,
  $UpsertParams as $CrewmemberRegattaNotificationUpsertParams,
} from './CrewmemberRegattaNotification';

import type {
  $ModelParams as $CrewmemberPushToken,
  $Associations as $CrewmemberPushTokenAssociations,
  $CreateParams as $CrewmemberPushTokenCreateParams,
  $QueryParams as $CrewmemberPushTokenQueryParams,
  $UpdateParams as $CrewmemberPushTokenUpdateParams,
  $UpsertParams as $CrewmemberPushTokenUpsertParams,
} from './CrewmemberPushToken';

import type {
  $ModelParams as $CrewmemberSocialUser,
  $Associations as $CrewmemberSocialUserAssociations,
  $CreateParams as $CrewmemberSocialUserCreateParams,
  $QueryParams as $CrewmemberSocialUserQueryParams,
  $UpdateParams as $CrewmemberSocialUserUpdateParams,
  $UpsertParams as $CrewmemberSocialUserUpsertParams,
} from './CrewmemberSocialUser';

import type {
  $ModelParams as $CustomPage,
  $Associations as $CustomPageAssociations,
  $CreateParams as $CustomPageCreateParams,
  $QueryParams as $CustomPageQueryParams,
  $UpdateParams as $CustomPageUpdateParams,
  $UpsertParams as $CustomPageUpsertParams,
} from './CustomPage';

import type {
  $ModelParams as $Entry,
  $Associations as $EntryAssociations,
  $CreateParams as $EntryCreateParams,
  $QueryParams as $EntryQueryParams,
  $UpdateParams as $EntryUpdateParams,
  $UpsertParams as $EntryUpsertParams,
} from './Entry';

import type {
  $ModelParams as $EntryRating,
  $Associations as $EntryRatingAssociations,
  $CreateParams as $EntryRatingCreateParams,
  $QueryParams as $EntryRatingQueryParams,
  $UpdateParams as $EntryRatingUpdateParams,
  $UpsertParams as $EntryRatingUpsertParams,
} from './EntryRating';

import type {
  $ModelParams as $Group,
  $Associations as $GroupAssociations,
  $CreateParams as $GroupCreateParams,
  $QueryParams as $GroupQueryParams,
  $UpdateParams as $GroupUpdateParams,
  $UpsertParams as $GroupUpsertParams,
} from './Group';

import type {
  $ModelParams as $RegattaNotification,
  $Associations as $RegattaNotificationAssociations,
  $CreateParams as $RegattaNotificationCreateParams,
  $QueryParams as $RegattaNotificationQueryParams,
  $UpdateParams as $RegattaNotificationUpdateParams,
  $UpsertParams as $RegattaNotificationUpsertParams,
} from './RegattaNotification';

import type {
  $ModelParams as $Rating,
  $Associations as $RatingAssociations,
  $CreateParams as $RatingCreateParams,
  $QueryParams as $RatingQueryParams,
  $UpdateParams as $RatingUpdateParams,
  $UpsertParams as $RatingUpsertParams,
} from './Rating';

import type {
  $ModelParams as $Regatta,
  $Associations as $RegattaAssociations,
  $CreateParams as $RegattaCreateParams,
  $QueryParams as $RegattaQueryParams,
  $UpdateParams as $RegattaUpdateParams,
  $UpsertParams as $RegattaUpsertParams,
} from './Regatta';

import type {
  $ModelParams as $RegattaAdmin,
  $Associations as $RegattaAdminAssociations,
  $CreateParams as $RegattaAdminCreateParams,
  $QueryParams as $RegattaAdminQueryParams,
  $UpdateParams as $RegattaAdminUpdateParams,
  $UpsertParams as $RegattaAdminUpsertParams,
} from './RegattaAdmin';

import type {
  $ModelParams as $RegattaAdminRequest,
  $Associations as $RegattaAdminRequestAssociations,
  $CreateParams as $RegattaAdminRequestCreateParams,
  $QueryParams as $RegattaAdminRequestQueryParams,
  $UpdateParams as $RegattaAdminRequestUpdateParams,
  $UpsertParams as $RegattaAdminRequestUpsertParams,
} from './RegattaAdminRequest';

import type {
  $ModelParams as $RegattaBoatRent,
  $Associations as $RegattaBoatRentAssociations,
  $CreateParams as $RegattaBoatRentCreateParams,
  $QueryParams as $RegattaBoatRentQueryParams,
  $UpdateParams as $RegattaBoatRentUpdateParams,
  $UpsertParams as $RegattaBoatRentUpsertParams,
} from './RegattaBoatRent';

import type {
  $ModelParams as $RegattaCheck,
  $Associations as $RegattaCheckAssociations,
  $CreateParams as $RegattaCheckCreateParams,
  $QueryParams as $RegattaCheckQueryParams,
  $UpdateParams as $RegattaCheckUpdateParams,
  $UpsertParams as $RegattaCheckUpsertParams,
} from './RegattaCheck';

import type {
  $ModelParams as $RegattaContact,
  $Associations as $RegattaContactAssociations,
  $CreateParams as $RegattaContactCreateParams,
  $QueryParams as $RegattaContactQueryParams,
  $UpdateParams as $RegattaContactUpdateParams,
  $UpsertParams as $RegattaContactUpsertParams,
} from './RegattaContact';

import type {
  $ModelParams as $RegattaCourse,
  $Associations as $RegattaCourseAssociations,
  $CreateParams as $RegattaCourseCreateParams,
  $QueryParams as $RegattaCourseQueryParams,
  $UpdateParams as $RegattaCourseUpdateParams,
  $UpsertParams as $RegattaCourseUpsertParams,
} from './RegattaCourse';

import type {
  $ModelParams as $RegattaCoursePoint,
  $Associations as $RegattaCoursePointAssociations,
  $CreateParams as $RegattaCoursePointCreateParams,
  $QueryParams as $RegattaCoursePointQueryParams,
  $UpdateParams as $RegattaCoursePointUpdateParams,
  $UpsertParams as $RegattaCoursePointUpsertParams,
} from './RegattaCoursePoint';

import type {
  $ModelParams as $RegattaCourseRace,
  $Associations as $RegattaCourseRaceAssociations,
  $CreateParams as $RegattaCourseRaceCreateParams,
  $QueryParams as $RegattaCourseRaceQueryParams,
  $UpdateParams as $RegattaCourseRaceUpdateParams,
  $UpsertParams as $RegattaCourseRaceUpsertParams,
} from './RegattaCourseRace';

import type {
  $ModelParams as $RegattaDocument,
  $Associations as $RegattaDocumentAssociations,
  $CreateParams as $RegattaDocumentCreateParams,
  $QueryParams as $RegattaDocumentQueryParams,
  $UpdateParams as $RegattaDocumentUpdateParams,
  $UpsertParams as $RegattaDocumentUpsertParams,
} from './RegattaDocument';

import type {
  $ModelParams as $RegattaDay,
  $Associations as $RegattaDayAssociations,
  $CreateParams as $RegattaDayCreateParams,
  $QueryParams as $RegattaDayQueryParams,
  $UpdateParams as $RegattaDayUpdateParams,
  $UpsertParams as $RegattaDayUpsertParams,
} from './RegattaDay';

import type {
  $ModelParams as $RegattaEntry,
  $Associations as $RegattaEntryAssociations,
  $CreateParams as $RegattaEntryCreateParams,
  $QueryParams as $RegattaEntryQueryParams,
  $UpdateParams as $RegattaEntryUpdateParams,
  $UpsertParams as $RegattaEntryUpsertParams,
} from './RegattaEntry';

import type {
  $ModelParams as $RegattaEntryCheck,
  $Associations as $RegattaEntryCheckAssociations,
  $CreateParams as $RegattaEntryCheckCreateParams,
  $QueryParams as $RegattaEntryCheckQueryParams,
  $UpdateParams as $RegattaEntryCheckUpdateParams,
  $UpsertParams as $RegattaEntryCheckUpsertParams,
} from './RegattaEntryCheck';

import type {
  $ModelParams as $RegattaEntryCrewmember,
  $Associations as $RegattaEntryCrewmemberAssociations,
  $CreateParams as $RegattaEntryCrewmemberCreateParams,
  $QueryParams as $RegattaEntryCrewmemberQueryParams,
  $UpdateParams as $RegattaEntryCrewmemberUpdateParams,
  $UpsertParams as $RegattaEntryCrewmemberUpsertParams,
} from './RegattaEntryCrewmember';

import type {
  $ModelParams as $RegattaEntryRating,
  $Associations as $RegattaEntryRatingAssociations,
  $CreateParams as $RegattaEntryRatingCreateParams,
  $QueryParams as $RegattaEntryRatingQueryParams,
  $UpdateParams as $RegattaEntryRatingUpdateParams,
  $UpsertParams as $RegattaEntryRatingUpsertParams,
} from './RegattaEntryRating';

import type {
  $ModelParams as $RegattaEntryRequirement,
  $Associations as $RegattaEntryRequirementAssociations,
  $CreateParams as $RegattaEntryRequirementCreateParams,
  $QueryParams as $RegattaEntryRequirementQueryParams,
  $UpdateParams as $RegattaEntryRequirementUpdateParams,
  $UpsertParams as $RegattaEntryRequirementUpsertParams,
} from './RegattaEntryRequirement';

import type {
  $ModelParams as $RegattaEntryTrackPoint,
  $Associations as $RegattaEntryTrackPointAssociations,
  $CreateParams as $RegattaEntryTrackPointCreateParams,
  $QueryParams as $RegattaEntryTrackPointQueryParams,
  $UpdateParams as $RegattaEntryTrackPointUpdateParams,
  $UpsertParams as $RegattaEntryTrackPointUpsertParams,
} from './RegattaEntryTrackPoint';

import type {
  $ModelParams as $RegattaGallery,
  $Associations as $RegattaGalleryAssociations,
  $CreateParams as $RegattaGalleryCreateParams,
  $QueryParams as $RegattaGalleryQueryParams,
  $UpdateParams as $RegattaGalleryUpdateParams,
  $UpsertParams as $RegattaGalleryUpsertParams,
} from './RegattaGallery';

import type {
  $ModelParams as $RegattaGroup,
  $Associations as $RegattaGroupAssociations,
  $CreateParams as $RegattaGroupCreateParams,
  $QueryParams as $RegattaGroupQueryParams,
  $UpdateParams as $RegattaGroupUpdateParams,
  $UpsertParams as $RegattaGroupUpsertParams,
} from './RegattaGroup';

import type {
  $ModelParams as $RegattaLog,
  $Associations as $RegattaLogAssociations,
  $CreateParams as $RegattaLogCreateParams,
  $QueryParams as $RegattaLogQueryParams,
  $UpdateParams as $RegattaLogUpdateParams,
  $UpsertParams as $RegattaLogUpsertParams,
} from './RegattaLog';

import type {
  $ModelParams as $RegattaMessage,
  $Associations as $RegattaMessageAssociations,
  $CreateParams as $RegattaMessageCreateParams,
  $QueryParams as $RegattaMessageQueryParams,
  $UpdateParams as $RegattaMessageUpdateParams,
  $UpsertParams as $RegattaMessageUpsertParams,
} from './RegattaMessage';

import type {
  $ModelParams as $RegattaPayment,
  $Associations as $RegattaPaymentAssociations,
  $CreateParams as $RegattaPaymentCreateParams,
  $QueryParams as $RegattaPaymentQueryParams,
  $UpdateParams as $RegattaPaymentUpdateParams,
  $UpsertParams as $RegattaPaymentUpsertParams,
} from './RegattaPayment';

import type {
  $ModelParams as $RegattaPaymentDiscount,
  $Associations as $RegattaPaymentDiscountAssociations,
  $CreateParams as $RegattaPaymentDiscountCreateParams,
  $QueryParams as $RegattaPaymentDiscountQueryParams,
  $UpdateParams as $RegattaPaymentDiscountUpdateParams,
  $UpsertParams as $RegattaPaymentDiscountUpsertParams,
} from './RegattaPaymentDiscount';

import type {
  $ModelParams as $RegattaProtest,
  $Associations as $RegattaProtestAssociations,
  $CreateParams as $RegattaProtestCreateParams,
  $QueryParams as $RegattaProtestQueryParams,
  $UpdateParams as $RegattaProtestUpdateParams,
  $UpsertParams as $RegattaProtestUpsertParams,
} from './RegattaProtest';

import type {
  $ModelParams as $RegattaProtestEnd,
  $Associations as $RegattaProtestEndAssociations,
  $CreateParams as $RegattaProtestEndCreateParams,
  $QueryParams as $RegattaProtestEndQueryParams,
  $UpdateParams as $RegattaProtestEndUpdateParams,
  $UpsertParams as $RegattaProtestEndUpsertParams,
} from './RegattaProtestEnd';

import type {
  $ModelParams as $RegattaRequirement,
  $Associations as $RegattaRequirementAssociations,
  $CreateParams as $RegattaRequirementCreateParams,
  $QueryParams as $RegattaRequirementQueryParams,
  $UpdateParams as $RegattaRequirementUpdateParams,
  $UpsertParams as $RegattaRequirementUpsertParams,
} from './RegattaRequirement';

import type {
  $ModelParams as $RegattaResultDiploma,
  $Associations as $RegattaResultDiplomaAssociations,
  $CreateParams as $RegattaResultDiplomaCreateParams,
  $QueryParams as $RegattaResultDiplomaQueryParams,
  $UpdateParams as $RegattaResultDiplomaUpdateParams,
  $UpsertParams as $RegattaResultDiplomaUpsertParams,
} from './RegattaResultDiploma';

import type {
  $ModelParams as $RegattaResultOverall,
  $Associations as $RegattaResultOverallAssociations,
  $CreateParams as $RegattaResultOverallCreateParams,
  $QueryParams as $RegattaResultOverallQueryParams,
  $UpdateParams as $RegattaResultOverallUpdateParams,
  $UpsertParams as $RegattaResultOverallUpsertParams,
} from './RegattaResultOverall';

import type {
  $ModelParams as $RegattaResultOverallEntry,
  $Associations as $RegattaResultOverallEntryAssociations,
  $CreateParams as $RegattaResultOverallEntryCreateParams,
  $QueryParams as $RegattaResultOverallEntryQueryParams,
  $UpdateParams as $RegattaResultOverallEntryUpdateParams,
  $UpsertParams as $RegattaResultOverallEntryUpsertParams,
} from './RegattaResultOverallEntry';

import type {
  $ModelParams as $RegattaResultOverallRegattaResultTable,
  $Associations as $RegattaResultOverallRegattaResultTableAssociations,
  $CreateParams as $RegattaResultOverallRegattaResultTableCreateParams,
  $QueryParams as $RegattaResultOverallRegattaResultTableQueryParams,
  $UpdateParams as $RegattaResultOverallRegattaResultTableUpdateParams,
  $UpsertParams as $RegattaResultOverallRegattaResultTableUpsertParams,
} from './RegattaResultOverallRegattaResultTable';

import type {
  $ModelParams as $RegattaResultTable,
  $Associations as $RegattaResultTableAssociations,
  $CreateParams as $RegattaResultTableCreateParams,
  $QueryParams as $RegattaResultTableQueryParams,
  $UpdateParams as $RegattaResultTableUpdateParams,
  $UpsertParams as $RegattaResultTableUpsertParams,
} from './RegattaResultTable';

import type {
  $ModelParams as $RegattaResultTableEntry,
  $Associations as $RegattaResultTableEntryAssociations,
  $CreateParams as $RegattaResultTableEntryCreateParams,
  $QueryParams as $RegattaResultTableEntryQueryParams,
  $UpdateParams as $RegattaResultTableEntryUpdateParams,
  $UpsertParams as $RegattaResultTableEntryUpsertParams,
} from './RegattaResultTableEntry';

import type {
  $ModelParams as $RegattaResultTableRace,
  $Associations as $RegattaResultTableRaceAssociations,
  $CreateParams as $RegattaResultTableRaceCreateParams,
  $QueryParams as $RegattaResultTableRaceQueryParams,
  $UpdateParams as $RegattaResultTableRaceUpdateParams,
  $UpsertParams as $RegattaResultTableRaceUpsertParams,
} from './RegattaResultTableRace';

import type {
  $ModelParams as $RegattaResultTableRaceResult,
  $Associations as $RegattaResultTableRaceResultAssociations,
  $CreateParams as $RegattaResultTableRaceResultCreateParams,
  $QueryParams as $RegattaResultTableRaceResultQueryParams,
  $UpdateParams as $RegattaResultTableRaceResultUpdateParams,
  $UpsertParams as $RegattaResultTableRaceResultUpsertParams,
} from './RegattaResultTableRaceResult';

import type {
  $ModelParams as $RegattaSchedule,
  $Associations as $RegattaScheduleAssociations,
  $CreateParams as $RegattaScheduleCreateParams,
  $QueryParams as $RegattaScheduleQueryParams,
  $UpdateParams as $RegattaScheduleUpdateParams,
  $UpsertParams as $RegattaScheduleUpsertParams,
} from './RegattaSchedule';

import type {
  $ModelParams as $RegattaSponsor,
  $Associations as $RegattaSponsorAssociations,
  $CreateParams as $RegattaSponsorCreateParams,
  $QueryParams as $RegattaSponsorQueryParams,
  $UpdateParams as $RegattaSponsorUpdateParams,
  $UpsertParams as $RegattaSponsorUpsertParams,
} from './RegattaSponsor';

import type {
  $ModelParams as $RegattaSubscription,
  $Associations as $RegattaSubscriptionAssociations,
  $CreateParams as $RegattaSubscriptionCreateParams,
  $QueryParams as $RegattaSubscriptionQueryParams,
  $UpdateParams as $RegattaSubscriptionUpdateParams,
  $UpsertParams as $RegattaSubscriptionUpsertParams,
} from './RegattaSubscription';

import type {
  $ModelParams as $RegattaTrackEvent,
  $Associations as $RegattaTrackEventAssociations,
  $CreateParams as $RegattaTrackEventCreateParams,
  $QueryParams as $RegattaTrackEventQueryParams,
  $UpdateParams as $RegattaTrackEventUpdateParams,
  $UpsertParams as $RegattaTrackEventUpsertParams,
} from './RegattaTrackEvent';

import type {
  $ModelParams as $RegattaTrackEventRegattaCourse,
  $Associations as $RegattaTrackEventRegattaCourseAssociations,
  $CreateParams as $RegattaTrackEventRegattaCourseCreateParams,
  $QueryParams as $RegattaTrackEventRegattaCourseQueryParams,
  $UpdateParams as $RegattaTrackEventRegattaCourseUpdateParams,
  $UpsertParams as $RegattaTrackEventRegattaCourseUpsertParams,
} from './RegattaTrackEventRegattaCourse';

import type {
  $ModelParams as $Region,
  $Associations as $RegionAssociations,
  $CreateParams as $RegionCreateParams,
  $QueryParams as $RegionQueryParams,
  $UpdateParams as $RegionUpdateParams,
  $UpsertParams as $RegionUpsertParams,
} from './Region';

import type {
  $ModelParams as $RegionSeason,
  $Associations as $RegionSeasonAssociations,
  $CreateParams as $RegionSeasonCreateParams,
  $QueryParams as $RegionSeasonQueryParams,
  $UpdateParams as $RegionSeasonUpdateParams,
  $UpsertParams as $RegionSeasonUpsertParams,
} from './RegionSeason';

import type {
  $ModelParams as $RegionSeasonRegattaLocation,
  $Associations as $RegionSeasonRegattaLocationAssociations,
  $CreateParams as $RegionSeasonRegattaLocationCreateParams,
  $QueryParams as $RegionSeasonRegattaLocationQueryParams,
  $UpdateParams as $RegionSeasonRegattaLocationUpdateParams,
  $UpsertParams as $RegionSeasonRegattaLocationUpsertParams,
} from './RegionSeasonRegattaLocation';

import Admin from './Admin';
import AdminAccessToken from './AdminAccessToken';
import AdminSocialUser from './AdminSocialUser';
import Advertisement from './Advertisement';
import Banner from './Banner';
import BannerLocation from './BannerLocation';
import Championship from './Championship';
import ChampionshipAdmin from './ChampionshipAdmin';
import ChampionshipAdminRequest from './ChampionshipAdminRequest';
import ChampionshipDocument from './ChampionshipDocument';
import ChampionshipRegatta from './ChampionshipRegatta';
import ChampionshipResultTable from './ChampionshipResultTable';
import ChampionshipResultTableEntry from './ChampionshipResultTableEntry';
import ChampionshipResultTableRace from './ChampionshipResultTableRace';
import ChampionshipResultTableRaceResult from './ChampionshipResultTableRaceResult';
import ChampionshipSponsor from './ChampionshipSponsor';
import ChampionshipSubscription from './ChampionshipSubscription';
import Crewmember from './Crewmember';
import CrewmemberAccessToken from './CrewmemberAccessToken';
import CrewmemberRegattaNotification from './CrewmemberRegattaNotification';
import CrewmemberPushToken from './CrewmemberPushToken';
import CrewmemberSocialUser from './CrewmemberSocialUser';
import CustomPage from './CustomPage';
import Entry from './Entry';
import EntryRating from './EntryRating';
import Group from './Group';
import RegattaNotification from './RegattaNotification';
import Rating from './Rating';
import Regatta from './Regatta';
import RegattaAdmin from './RegattaAdmin';
import RegattaAdminRequest from './RegattaAdminRequest';
import RegattaBoatRent from './RegattaBoatRent';
import RegattaCheck from './RegattaCheck';
import RegattaContact from './RegattaContact';
import RegattaCourse from './RegattaCourse';
import RegattaCoursePoint from './RegattaCoursePoint';
import RegattaCourseRace from './RegattaCourseRace';
import RegattaDay from './RegattaDay';
import RegattaDocument from './RegattaDocument';
import RegattaEntry from './RegattaEntry';
import RegattaEntryCheck from './RegattaEntryCheck';
import RegattaEntryCrewmember from './RegattaEntryCrewmember';
import RegattaEntryRating from './RegattaEntryRating';
import RegattaEntryRequirement from './RegattaEntryRequirement';
import RegattaEntryTrackPoint from './RegattaEntryTrackPoint';
import RegattaGallery from './RegattaGallery';
import RegattaGroup from './RegattaGroup';
import RegattaLog from './RegattaLog';
import RegattaMessage from './RegattaMessage';
import RegattaPayment from './RegattaPayment';
import RegattaPaymentDiscount from './RegattaPaymentDiscount';
import RegattaProtest from './RegattaProtest';
import RegattaProtestEnd from './RegattaProtestEnd';
import RegattaRequirement from './RegattaRequirement';
import RegattaResultDiploma from './RegattaResultDiploma';
import RegattaResultOverall from './RegattaResultOverall';
import RegattaResultOverallEntry from './RegattaResultOverallEntry';
import RegattaResultOverallRegattaResultTable from './RegattaResultOverallRegattaResultTable';
import RegattaResultTable from './RegattaResultTable';
import RegattaResultTableEntry from './RegattaResultTableEntry';
import RegattaResultTableRace from './RegattaResultTableRace';
import RegattaResultTableRaceResult from './RegattaResultTableRaceResult';
import RegattaSchedule from './RegattaSchedule';
import RegattaSponsor from './RegattaSponsor';
import RegattaSubscription from './RegattaSubscription';
import RegattaTrackEvent from './RegattaTrackEvent';
import RegattaTrackEventRegattaCourse from './RegattaTrackEventRegattaCourse';
import Region from './Region';
import RegionSeason from './RegionSeason';
import RegionSeasonRegattaLocation from './RegionSeasonRegattaLocation';

export type $ModelsConfig = {
  Admin: {
    ModelAssociations: $AdminAssociations;
    ModelCreateParams: $AdminCreateParams;
    ModelParams: $Admin;
    ModelQueryParams: $AdminQueryParams;
    ModelUpdateParams: $AdminUpdateParams;
    ModelUpsertParams: $AdminUpsertParams;
  };
  AdminAccessToken: {
    ModelAssociations: $AdminAccessTokenAssociations;
    ModelCreateParams: $AdminAccessTokenCreateParams;
    ModelParams: $AdminAccessToken;
    ModelQueryParams: $AdminAccessTokenQueryParams;
    ModelUpdateParams: $AdminAccessTokenUpdateParams;
    ModelUpsertParams: $AdminAccessTokenUpsertParams;
  };
  AdminSocialUser: {
    ModelAssociations: $AdminSocialUserAssociations;
    ModelCreateParams: $AdminSocialUserCreateParams;
    ModelParams: $AdminSocialUser;
    ModelQueryParams: $AdminSocialUserQueryParams;
    ModelUpdateParams: $AdminSocialUserUpdateParams;
    ModelUpsertParams: $AdminSocialUserUpsertParams;
  };
  Advertisement: {
    ModelAssociations: $AdvertisementAssociations;
    ModelCreateParams: $AdvertisementCreateParams;
    ModelParams: $Advertisement;
    ModelQueryParams: $AdvertisementQueryParams;
    ModelUpdateParams: $AdvertisementUpdateParams;
    ModelUpsertParams: $AdvertisementUpsertParams;
  };
  Banner: {
    ModelAssociations: $BannerAssociations;
    ModelCreateParams: $BannerCreateParams;
    ModelParams: $Banner;
    ModelQueryParams: $BannerQueryParams;
    ModelUpdateParams: $BannerUpdateParams;
    ModelUpsertParams: $BannerUpsertParams;
  };
  BannerLocation: {
    ModelAssociations: $BannerLocationAssociations;
    ModelCreateParams: $BannerLocationCreateParams;
    ModelParams: $BannerLocation;
    ModelQueryParams: $BannerLocationQueryParams;
    ModelUpdateParams: $BannerLocationUpdateParams;
    ModelUpsertParams: $BannerLocationUpsertParams;
  };
  Championship: {
    ModelAssociations: $ChampionshipAssociations;
    ModelCreateParams: $ChampionshipCreateParams;
    ModelParams: $Championship;
    ModelQueryParams: $ChampionshipQueryParams;
    ModelUpdateParams: $ChampionshipUpdateParams;
    ModelUpsertParams: $ChampionshipUpsertParams;
  };
  ChampionshipAdmin: {
    ModelAssociations: $ChampionshipAdminAssociations;
    ModelCreateParams: $ChampionshipAdminCreateParams;
    ModelParams: $ChampionshipAdmin;
    ModelQueryParams: $ChampionshipAdminQueryParams;
    ModelUpdateParams: $ChampionshipAdminUpdateParams;
    ModelUpsertParams: $ChampionshipAdminUpsertParams;
  };
  ChampionshipAdminRequest: {
    ModelAssociations: $ChampionshipAdminRequestAssociations;
    ModelCreateParams: $ChampionshipAdminRequestCreateParams;
    ModelParams: $ChampionshipAdminRequest;
    ModelQueryParams: $ChampionshipAdminRequestQueryParams;
    ModelUpdateParams: $ChampionshipAdminRequestUpdateParams;
    ModelUpsertParams: $ChampionshipAdminRequestUpsertParams;
  };
  ChampionshipDocument: {
    ModelAssociations: $ChampionshipDocumentAssociations;
    ModelCreateParams: $ChampionshipDocumentCreateParams;
    ModelParams: $ChampionshipDocument;
    ModelQueryParams: $ChampionshipDocumentQueryParams;
    ModelUpdateParams: $ChampionshipDocumentUpdateParams;
    ModelUpsertParams: $ChampionshipDocumentUpsertParams;
  };
  ChampionshipRegatta: {
    ModelAssociations: $ChampionshipRegattaAssociations;
    ModelCreateParams: $ChampionshipRegattaCreateParams;
    ModelParams: $ChampionshipRegatta;
    ModelQueryParams: $ChampionshipRegattaQueryParams;
    ModelUpdateParams: $ChampionshipRegattaUpdateParams;
    ModelUpsertParams: $ChampionshipRegattaUpsertParams;
  };
  ChampionshipResultTable: {
    ModelAssociations: $ChampionshipResultTableAssociations;
    ModelCreateParams: $ChampionshipResultTableCreateParams;
    ModelParams: $ChampionshipResultTable;
    ModelQueryParams: $ChampionshipResultTableQueryParams;
    ModelUpdateParams: $ChampionshipResultTableUpdateParams;
    ModelUpsertParams: $ChampionshipResultTableUpsertParams;
  };
  ChampionshipResultTableEntry: {
    ModelAssociations: $ChampionshipResultTableEntryAssociations;
    ModelCreateParams: $ChampionshipResultTableEntryCreateParams;
    ModelParams: $ChampionshipResultTableEntry;
    ModelQueryParams: $ChampionshipResultTableEntryQueryParams;
    ModelUpdateParams: $ChampionshipResultTableEntryUpdateParams;
    ModelUpsertParams: $ChampionshipResultTableEntryUpsertParams;
  };
  ChampionshipResultTableRace: {
    ModelAssociations: $ChampionshipResultTableRaceAssociations;
    ModelCreateParams: $ChampionshipResultTableRaceCreateParams;
    ModelParams: $ChampionshipResultTableRace;
    ModelQueryParams: $ChampionshipResultTableRaceQueryParams;
    ModelUpdateParams: $ChampionshipResultTableRaceUpdateParams;
    ModelUpsertParams: $ChampionshipResultTableRaceUpsertParams;
  };
  ChampionshipResultTableRaceResult: {
    ModelAssociations: $ChampionshipResultTableRaceResultAssociations;
    ModelCreateParams: $ChampionshipResultTableRaceResultCreateParams;
    ModelParams: $ChampionshipResultTableRaceResult;
    ModelQueryParams: $ChampionshipResultTableRaceResultQueryParams;
    ModelUpdateParams: $ChampionshipResultTableRaceResultUpdateParams;
    ModelUpsertParams: $ChampionshipResultTableRaceResultUpsertParams;
  };
  ChampionshipSponsor: {
    ModelAssociations: $ChampionshipSponsorAssociations;
    ModelCreateParams: $ChampionshipSponsorCreateParams;
    ModelParams: $ChampionshipSponsor;
    ModelQueryParams: $ChampionshipSponsorQueryParams;
    ModelUpdateParams: $ChampionshipSponsorUpdateParams;
    ModelUpsertParams: $ChampionshipSponsorUpsertParams;
  };
  ChampionshipSubscription: {
    ModelAssociations: $ChampionshipSubscriptionAssociations;
    ModelCreateParams: $ChampionshipSubscriptionCreateParams;
    ModelParams: $ChampionshipSubscription;
    ModelQueryParams: $ChampionshipSubscriptionQueryParams;
    ModelUpdateParams: $ChampionshipSubscriptionUpdateParams;
    ModelUpsertParams: $ChampionshipSubscriptionUpsertParams;
  };
  Crewmember: {
    ModelAssociations: $CrewmemberAssociations;
    ModelCreateParams: $CrewmemberCreateParams;
    ModelParams: $Crewmember;
    ModelQueryParams: $CrewmemberQueryParams;
    ModelUpdateParams: $CrewmemberUpdateParams;
    ModelUpsertParams: $CrewmemberUpsertParams;
  };
  CrewmemberAccessToken: {
    ModelAssociations: $CrewmemberAccessTokenAssociations;
    ModelCreateParams: $CrewmemberAccessTokenCreateParams;
    ModelParams: $CrewmemberAccessToken;
    ModelQueryParams: $CrewmemberAccessTokenQueryParams;
    ModelUpdateParams: $CrewmemberAccessTokenUpdateParams;
    ModelUpsertParams: $CrewmemberAccessTokenUpsertParams;
  };
  CrewmemberPushToken: {
    ModelAssociations: $CrewmemberPushTokenAssociations;
    ModelCreateParams: $CrewmemberPushTokenCreateParams;
    ModelParams: $CrewmemberPushToken;
    ModelQueryParams: $CrewmemberPushTokenQueryParams;
    ModelUpdateParams: $CrewmemberPushTokenUpdateParams;
    ModelUpsertParams: $CrewmemberPushTokenUpsertParams;
  };
  CrewmemberRegattaNotification: {
    ModelAssociations: $CrewmemberRegattaNotificationAssociations;
    ModelCreateParams: $CrewmemberRegattaNotificationCreateParams;
    ModelParams: $CrewmemberRegattaNotification;
    ModelQueryParams: $CrewmemberRegattaNotificationQueryParams;
    ModelUpdateParams: $CrewmemberRegattaNotificationUpdateParams;
    ModelUpsertParams: $CrewmemberRegattaNotificationUpsertParams;
  };
  CrewmemberSocialUser: {
    ModelAssociations: $CrewmemberSocialUserAssociations;
    ModelCreateParams: $CrewmemberSocialUserCreateParams;
    ModelParams: $CrewmemberSocialUser;
    ModelQueryParams: $CrewmemberSocialUserQueryParams;
    ModelUpdateParams: $CrewmemberSocialUserUpdateParams;
    ModelUpsertParams: $CrewmemberSocialUserUpsertParams;
  };
  CustomPage: {
    ModelAssociations: $CustomPageAssociations;
    ModelCreateParams: $CustomPageCreateParams;
    ModelParams: $CustomPage;
    ModelQueryParams: $CustomPageQueryParams;
    ModelUpdateParams: $CustomPageUpdateParams;
    ModelUpsertParams: $CustomPageUpsertParams;
  };
  Entry: {
    ModelAssociations: $EntryAssociations;
    ModelCreateParams: $EntryCreateParams;
    ModelParams: $Entry;
    ModelQueryParams: $EntryQueryParams;
    ModelUpdateParams: $EntryUpdateParams;
    ModelUpsertParams: $EntryUpsertParams;
  };
  EntryRating: {
    ModelAssociations: $EntryRatingAssociations;
    ModelCreateParams: $EntryRatingCreateParams;
    ModelParams: $EntryRating;
    ModelQueryParams: $EntryRatingQueryParams;
    ModelUpdateParams: $EntryRatingUpdateParams;
    ModelUpsertParams: $EntryRatingUpsertParams;
  };
  Group: {
    ModelAssociations: $GroupAssociations;
    ModelCreateParams: $GroupCreateParams;
    ModelParams: $Group;
    ModelQueryParams: $GroupQueryParams;
    ModelUpdateParams: $GroupUpdateParams;
    ModelUpsertParams: $GroupUpsertParams;
  };
  Rating: {
    ModelAssociations: $RatingAssociations;
    ModelCreateParams: $RatingCreateParams;
    ModelParams: $Rating;
    ModelQueryParams: $RatingQueryParams;
    ModelUpdateParams: $RatingUpdateParams;
    ModelUpsertParams: $RatingUpsertParams;
  };
  Regatta: {
    ModelAssociations: $RegattaAssociations;
    ModelCreateParams: $RegattaCreateParams;
    ModelParams: $Regatta;
    ModelQueryParams: $RegattaQueryParams;
    ModelUpdateParams: $RegattaUpdateParams;
    ModelUpsertParams: $RegattaUpsertParams;
  };
  RegattaAdmin: {
    ModelAssociations: $RegattaAdminAssociations;
    ModelCreateParams: $RegattaAdminCreateParams;
    ModelParams: $RegattaAdmin;
    ModelQueryParams: $RegattaAdminQueryParams;
    ModelUpdateParams: $RegattaAdminUpdateParams;
    ModelUpsertParams: $RegattaAdminUpsertParams;
  };
  RegattaAdminRequest: {
    ModelAssociations: $RegattaAdminRequestAssociations;
    ModelCreateParams: $RegattaAdminRequestCreateParams;
    ModelParams: $RegattaAdminRequest;
    ModelQueryParams: $RegattaAdminRequestQueryParams;
    ModelUpdateParams: $RegattaAdminRequestUpdateParams;
    ModelUpsertParams: $RegattaAdminRequestUpsertParams;
  };
  RegattaBoatRent: {
    ModelAssociations: $RegattaBoatRentAssociations;
    ModelCreateParams: $RegattaBoatRentCreateParams;
    ModelParams: $RegattaBoatRent;
    ModelQueryParams: $RegattaBoatRentQueryParams;
    ModelUpdateParams: $RegattaBoatRentUpdateParams;
    ModelUpsertParams: $RegattaBoatRentUpsertParams;
  };
  RegattaCheck: {
    ModelAssociations: $RegattaCheckAssociations;
    ModelCreateParams: $RegattaCheckCreateParams;
    ModelParams: $RegattaCheck;
    ModelQueryParams: $RegattaCheckQueryParams;
    ModelUpdateParams: $RegattaCheckUpdateParams;
    ModelUpsertParams: $RegattaCheckUpsertParams;
  };
  RegattaContact: {
    ModelAssociations: $RegattaContactAssociations;
    ModelCreateParams: $RegattaContactCreateParams;
    ModelParams: $RegattaContact;
    ModelQueryParams: $RegattaContactQueryParams;
    ModelUpdateParams: $RegattaContactUpdateParams;
    ModelUpsertParams: $RegattaContactUpsertParams;
  };
  RegattaCourse: {
    ModelAssociations: $RegattaCourseAssociations;
    ModelCreateParams: $RegattaCourseCreateParams;
    ModelParams: $RegattaCourse;
    ModelQueryParams: $RegattaCourseQueryParams;
    ModelUpdateParams: $RegattaCourseUpdateParams;
    ModelUpsertParams: $RegattaCourseUpsertParams;
  };
  RegattaCoursePoint: {
    ModelAssociations: $RegattaCoursePointAssociations;
    ModelCreateParams: $RegattaCoursePointCreateParams;
    ModelParams: $RegattaCoursePoint;
    ModelQueryParams: $RegattaCoursePointQueryParams;
    ModelUpdateParams: $RegattaCoursePointUpdateParams;
    ModelUpsertParams: $RegattaCoursePointUpsertParams;
  };
  RegattaCourseRace: {
    ModelAssociations: $RegattaCourseRaceAssociations;
    ModelCreateParams: $RegattaCourseRaceCreateParams;
    ModelParams: $RegattaCourseRace;
    ModelQueryParams: $RegattaCourseRaceQueryParams;
    ModelUpdateParams: $RegattaCourseRaceUpdateParams;
    ModelUpsertParams: $RegattaCourseRaceUpsertParams;
  };
  RegattaDay: {
    ModelAssociations: $RegattaDayAssociations;
    ModelCreateParams: $RegattaDayCreateParams;
    ModelParams: $RegattaDay;
    ModelQueryParams: $RegattaDayQueryParams;
    ModelUpdateParams: $RegattaDayUpdateParams;
    ModelUpsertParams: $RegattaDayUpsertParams;
  };
  RegattaDocument: {
    ModelAssociations: $RegattaDocumentAssociations;
    ModelCreateParams: $RegattaDocumentCreateParams;
    ModelParams: $RegattaDocument;
    ModelQueryParams: $RegattaDocumentQueryParams;
    ModelUpdateParams: $RegattaDocumentUpdateParams;
    ModelUpsertParams: $RegattaDocumentUpsertParams;
  };
  RegattaEntry: {
    ModelAssociations: $RegattaEntryAssociations;
    ModelCreateParams: $RegattaEntryCreateParams;
    ModelParams: $RegattaEntry;
    ModelQueryParams: $RegattaEntryQueryParams;
    ModelUpdateParams: $RegattaEntryUpdateParams;
    ModelUpsertParams: $RegattaEntryUpsertParams;
  };
  RegattaEntryCheck: {
    ModelAssociations: $RegattaEntryCheckAssociations;
    ModelCreateParams: $RegattaEntryCheckCreateParams;
    ModelParams: $RegattaEntryCheck;
    ModelQueryParams: $RegattaEntryCheckQueryParams;
    ModelUpdateParams: $RegattaEntryCheckUpdateParams;
    ModelUpsertParams: $RegattaEntryCheckUpsertParams;
  };
  RegattaEntryCrewmember: {
    ModelAssociations: $RegattaEntryCrewmemberAssociations;
    ModelCreateParams: $RegattaEntryCrewmemberCreateParams;
    ModelParams: $RegattaEntryCrewmember;
    ModelQueryParams: $RegattaEntryCrewmemberQueryParams;
    ModelUpdateParams: $RegattaEntryCrewmemberUpdateParams;
    ModelUpsertParams: $RegattaEntryCrewmemberUpsertParams;
  };
  RegattaEntryRating: {
    ModelAssociations: $RegattaEntryRatingAssociations;
    ModelCreateParams: $RegattaEntryRatingCreateParams;
    ModelParams: $RegattaEntryRating;
    ModelQueryParams: $RegattaEntryRatingQueryParams;
    ModelUpdateParams: $RegattaEntryRatingUpdateParams;
    ModelUpsertParams: $RegattaEntryRatingUpsertParams;
  };
  RegattaEntryRequirement: {
    ModelAssociations: $RegattaEntryRequirementAssociations;
    ModelCreateParams: $RegattaEntryRequirementCreateParams;
    ModelParams: $RegattaEntryRequirement;
    ModelQueryParams: $RegattaEntryRequirementQueryParams;
    ModelUpdateParams: $RegattaEntryRequirementUpdateParams;
    ModelUpsertParams: $RegattaEntryRequirementUpsertParams;
  };
  RegattaEntryTrackPoint: {
    ModelAssociations: $RegattaEntryTrackPointAssociations;
    ModelCreateParams: $RegattaEntryTrackPointCreateParams;
    ModelParams: $RegattaEntryTrackPoint;
    ModelQueryParams: $RegattaEntryTrackPointQueryParams;
    ModelUpdateParams: $RegattaEntryTrackPointUpdateParams;
    ModelUpsertParams: $RegattaEntryTrackPointUpsertParams;
  };
  RegattaGallery: {
    ModelAssociations: $RegattaGalleryAssociations;
    ModelCreateParams: $RegattaGalleryCreateParams;
    ModelParams: $RegattaGallery;
    ModelQueryParams: $RegattaGalleryQueryParams;
    ModelUpdateParams: $RegattaGalleryUpdateParams;
    ModelUpsertParams: $RegattaGalleryUpsertParams;
  };
  RegattaGroup: {
    ModelAssociations: $RegattaGroupAssociations;
    ModelCreateParams: $RegattaGroupCreateParams;
    ModelParams: $RegattaGroup;
    ModelQueryParams: $RegattaGroupQueryParams;
    ModelUpdateParams: $RegattaGroupUpdateParams;
    ModelUpsertParams: $RegattaGroupUpsertParams;
  };
  RegattaLog: {
    ModelAssociations: $RegattaLogAssociations;
    ModelCreateParams: $RegattaLogCreateParams;
    ModelParams: $RegattaLog;
    ModelQueryParams: $RegattaLogQueryParams;
    ModelUpdateParams: $RegattaLogUpdateParams;
    ModelUpsertParams: $RegattaLogUpsertParams;
  };
  RegattaMessage: {
    ModelAssociations: $RegattaMessageAssociations;
    ModelCreateParams: $RegattaMessageCreateParams;
    ModelParams: $RegattaMessage;
    ModelQueryParams: $RegattaMessageQueryParams;
    ModelUpdateParams: $RegattaMessageUpdateParams;
    ModelUpsertParams: $RegattaMessageUpsertParams;
  };
  RegattaNotification: {
    ModelAssociations: $RegattaNotificationAssociations;
    ModelCreateParams: $RegattaNotificationCreateParams;
    ModelParams: $RegattaNotification;
    ModelQueryParams: $RegattaNotificationQueryParams;
    ModelUpdateParams: $RegattaNotificationUpdateParams;
    ModelUpsertParams: $RegattaNotificationUpsertParams;
  };
  RegattaPayment: {
    ModelAssociations: $RegattaPaymentAssociations;
    ModelCreateParams: $RegattaPaymentCreateParams;
    ModelParams: $RegattaPayment;
    ModelQueryParams: $RegattaPaymentQueryParams;
    ModelUpdateParams: $RegattaPaymentUpdateParams;
    ModelUpsertParams: $RegattaPaymentUpsertParams;
  };
  RegattaPaymentDiscount: {
    ModelAssociations: $RegattaPaymentDiscountAssociations;
    ModelCreateParams: $RegattaPaymentDiscountCreateParams;
    ModelParams: $RegattaPaymentDiscount;
    ModelQueryParams: $RegattaPaymentDiscountQueryParams;
    ModelUpdateParams: $RegattaPaymentDiscountUpdateParams;
    ModelUpsertParams: $RegattaPaymentDiscountUpsertParams;
  };
  RegattaProtest: {
    ModelAssociations: $RegattaProtestAssociations;
    ModelCreateParams: $RegattaProtestCreateParams;
    ModelParams: $RegattaProtest;
    ModelQueryParams: $RegattaProtestQueryParams;
    ModelUpdateParams: $RegattaProtestUpdateParams;
    ModelUpsertParams: $RegattaProtestUpsertParams;
  };
  RegattaProtestEnd: {
    ModelAssociations: $RegattaProtestEndAssociations;
    ModelCreateParams: $RegattaProtestEndCreateParams;
    ModelParams: $RegattaProtestEnd;
    ModelQueryParams: $RegattaProtestEndQueryParams;
    ModelUpdateParams: $RegattaProtestEndUpdateParams;
    ModelUpsertParams: $RegattaProtestEndUpsertParams;
  };
  RegattaRequirement: {
    ModelAssociations: $RegattaRequirementAssociations;
    ModelCreateParams: $RegattaRequirementCreateParams;
    ModelParams: $RegattaRequirement;
    ModelQueryParams: $RegattaRequirementQueryParams;
    ModelUpdateParams: $RegattaRequirementUpdateParams;
    ModelUpsertParams: $RegattaRequirementUpsertParams;
  };
  RegattaResultDiploma: {
    ModelAssociations: $RegattaResultDiplomaAssociations;
    ModelCreateParams: $RegattaResultDiplomaCreateParams;
    ModelParams: $RegattaResultDiploma;
    ModelQueryParams: $RegattaResultDiplomaQueryParams;
    ModelUpdateParams: $RegattaResultDiplomaUpdateParams;
    ModelUpsertParams: $RegattaResultDiplomaUpsertParams;
  };
  RegattaResultOverall: {
    ModelAssociations: $RegattaResultOverallAssociations;
    ModelCreateParams: $RegattaResultOverallCreateParams;
    ModelParams: $RegattaResultOverall;
    ModelQueryParams: $RegattaResultOverallQueryParams;
    ModelUpdateParams: $RegattaResultOverallUpdateParams;
    ModelUpsertParams: $RegattaResultOverallUpsertParams;
  };
  RegattaResultOverallEntry: {
    ModelAssociations: $RegattaResultOverallEntryAssociations;
    ModelCreateParams: $RegattaResultOverallEntryCreateParams;
    ModelParams: $RegattaResultOverallEntry;
    ModelQueryParams: $RegattaResultOverallEntryQueryParams;
    ModelUpdateParams: $RegattaResultOverallEntryUpdateParams;
    ModelUpsertParams: $RegattaResultOverallEntryUpsertParams;
  };
  RegattaResultOverallRegattaResultTable: {
    ModelAssociations: $RegattaResultOverallRegattaResultTableAssociations;
    ModelCreateParams: $RegattaResultOverallRegattaResultTableCreateParams;
    ModelParams: $RegattaResultOverallRegattaResultTable;
    ModelQueryParams: $RegattaResultOverallRegattaResultTableQueryParams;
    ModelUpdateParams: $RegattaResultOverallRegattaResultTableUpdateParams;
    ModelUpsertParams: $RegattaResultOverallRegattaResultTableUpsertParams;
  };
  RegattaResultTable: {
    ModelAssociations: $RegattaResultTableAssociations;
    ModelCreateParams: $RegattaResultTableCreateParams;
    ModelParams: $RegattaResultTable;
    ModelQueryParams: $RegattaResultTableQueryParams;
    ModelUpdateParams: $RegattaResultTableUpdateParams;
    ModelUpsertParams: $RegattaResultTableUpsertParams;
  };
  RegattaResultTableEntry: {
    ModelAssociations: $RegattaResultTableEntryAssociations;
    ModelCreateParams: $RegattaResultTableEntryCreateParams;
    ModelParams: $RegattaResultTableEntry;
    ModelQueryParams: $RegattaResultTableEntryQueryParams;
    ModelUpdateParams: $RegattaResultTableEntryUpdateParams;
    ModelUpsertParams: $RegattaResultTableEntryUpsertParams;
  };
  RegattaResultTableRace: {
    ModelAssociations: $RegattaResultTableRaceAssociations;
    ModelCreateParams: $RegattaResultTableRaceCreateParams;
    ModelParams: $RegattaResultTableRace;
    ModelQueryParams: $RegattaResultTableRaceQueryParams;
    ModelUpdateParams: $RegattaResultTableRaceUpdateParams;
    ModelUpsertParams: $RegattaResultTableRaceUpsertParams;
  };
  RegattaResultTableRaceResult: {
    ModelAssociations: $RegattaResultTableRaceResultAssociations;
    ModelCreateParams: $RegattaResultTableRaceResultCreateParams;
    ModelParams: $RegattaResultTableRaceResult;
    ModelQueryParams: $RegattaResultTableRaceResultQueryParams;
    ModelUpdateParams: $RegattaResultTableRaceResultUpdateParams;
    ModelUpsertParams: $RegattaResultTableRaceResultUpsertParams;
  };
  RegattaSchedule: {
    ModelAssociations: $RegattaScheduleAssociations;
    ModelCreateParams: $RegattaScheduleCreateParams;
    ModelParams: $RegattaSchedule;
    ModelQueryParams: $RegattaScheduleQueryParams;
    ModelUpdateParams: $RegattaScheduleUpdateParams;
    ModelUpsertParams: $RegattaScheduleUpsertParams;
  };
  RegattaSponsor: {
    ModelAssociations: $RegattaSponsorAssociations;
    ModelCreateParams: $RegattaSponsorCreateParams;
    ModelParams: $RegattaSponsor;
    ModelQueryParams: $RegattaSponsorQueryParams;
    ModelUpdateParams: $RegattaSponsorUpdateParams;
    ModelUpsertParams: $RegattaSponsorUpsertParams;
  };
  RegattaSubscription: {
    ModelAssociations: $RegattaSubscriptionAssociations;
    ModelCreateParams: $RegattaSubscriptionCreateParams;
    ModelParams: $RegattaSubscription;
    ModelQueryParams: $RegattaSubscriptionQueryParams;
    ModelUpdateParams: $RegattaSubscriptionUpdateParams;
    ModelUpsertParams: $RegattaSubscriptionUpsertParams;
  };
  RegattaTrackEvent: {
    ModelAssociations: $RegattaTrackEventAssociations;
    ModelCreateParams: $RegattaTrackEventCreateParams;
    ModelParams: $RegattaTrackEvent;
    ModelQueryParams: $RegattaTrackEventQueryParams;
    ModelUpdateParams: $RegattaTrackEventUpdateParams;
    ModelUpsertParams: $RegattaTrackEventUpsertParams;
  };
  RegattaTrackEventRegattaCourse: {
    ModelAssociations: $RegattaTrackEventRegattaCourseAssociations;
    ModelCreateParams: $RegattaTrackEventRegattaCourseCreateParams;
    ModelParams: $RegattaTrackEventRegattaCourse;
    ModelQueryParams: $RegattaTrackEventRegattaCourseQueryParams;
    ModelUpdateParams: $RegattaTrackEventRegattaCourseUpdateParams;
    ModelUpsertParams: $RegattaTrackEventRegattaCourseUpsertParams;
  };
  Region: {
    ModelAssociations: $RegionAssociations;
    ModelCreateParams: $RegionCreateParams;
    ModelParams: $Region;
    ModelQueryParams: $RegionQueryParams;
    ModelUpdateParams: $RegionUpdateParams;
    ModelUpsertParams: $RegionUpsertParams;
  };
  RegionSeason: {
    ModelAssociations: $RegionSeasonAssociations;
    ModelCreateParams: $RegionSeasonCreateParams;
    ModelParams: $RegionSeason;
    ModelQueryParams: $RegionSeasonQueryParams;
    ModelUpdateParams: $RegionSeasonUpdateParams;
    ModelUpsertParams: $RegionSeasonUpsertParams;
  };
  RegionSeasonRegattaLocation: {
    ModelAssociations: $RegionSeasonRegattaLocationAssociations;
    ModelCreateParams: $RegionSeasonRegattaLocationCreateParams;
    ModelParams: $RegionSeasonRegattaLocation;
    ModelQueryParams: $RegionSeasonRegattaLocationQueryParams;
    ModelUpdateParams: $RegionSeasonRegattaLocationUpdateParams;
    ModelUpsertParams: $RegionSeasonRegattaLocationUpsertParams;
  };
};

export type $ModelName = keyof $ModelsConfig;
export type $ModelCreateParams<M extends $ModelName> = $ModelsConfig[M]['ModelCreateParams'];
export type $ModelUpdateParams<M extends $ModelName> = $ModelsConfig[M]['ModelUpdateParams'];
export type $ModelUpsertParams<M extends $ModelName> = $ModelsConfig[M]['ModelUpsertParams'];
export type $ModelQueryParams<M extends $ModelName> = $ModelsConfig[M]['ModelQueryParams'];
export type $ModelAssociations<M extends $ModelName> = $ModelsConfig[M]['ModelAssociations'];
export type $ModelParams<M extends $ModelName> = $ModelsConfig[M]['ModelParams'];

export type $Where<M extends $ModelName> = $ModelsConfig[M]['ModelQueryParams'] & {
  [key: string]: boolean | number | Record<string, unknown> | string | undefined;
};

type $IncludeInside<M extends $ModelName> = {
  as?: string;
  // eslint-disable-next-line no-use-before-define
  model: $ModelClass<M>;
  where: $Where<M>;
} | M;
export type $Include<M extends $ModelName> = Array<$IncludeInside<M> | string>;

export type $QueryParams<M extends $ModelName> = {
  // attributes?: Array<keyof $ModelQueryParams<M>>,
  attributes?: Array<string>;
  // include?: $Include<keyof $ModelAssociations<M>>,
  include?: $Include<$ModelName>;
  where?: $Where<M>;
};

export type $Model<M extends $ModelName> = $ModelParams<M> & {
  createdAt: Date;
  destroy?: () => Promise<void>;
  update?: <UM extends $ModelName>(arg0: $ModelUpdateParams<UM>) => Promise<$Model<UM>>;
  updatedAt: Date;
};

export type $ModelClass<M extends $ModelName> = {
  associate: () => void;
  belongsTo: <BTM extends $ModelName>(arg0: $ModelClass<BTM>, arg1: {
    as?: string;
    constraints?: boolean;
    foreignKey?: string;
    targetKey?: string;
  } | void) => void;
  belongsToMany: <BTMM extends $ModelName, BTMRM extends $ModelName>(
    arg0: $ModelClass<BTMM>,
    arg1: {
      as: string;
      foreignKey: string;
      otherKey: string;
      through: $ModelClass<BTMRM>;
    },
  ) => void;
  bulkCreate: <MBC extends $ModelName>(
    arg0: Array<$ModelCreateParams<MBC>>,
  ) => Promise<Array<$Model<MBC>>>;
  count: <MC extends $ModelName>(arg0: $QueryParams<MC>) => Promise<number>;
  create: <MC extends $ModelName>(arg0: $ModelCreateParams<MC>, arg1: {
    include: $Include<$ModelName>;
  } | void) => Promise<$Model<MC>>;
  findAll: <MFA extends $ModelName>(arg0: $QueryParams<$ModelName>) => Promise<Array<$Model<MFA>>>;
  findByPk: <MFBK extends $ModelName>(arg0: string) => Promise<$Model<MFBK> | null>;
  findOne: <MFO extends $ModelName>(arg0: $QueryParams<MFO>) => Promise<$Model<MFO> | null>;
  hasMany: <HMM extends $ModelName>(arg0: $ModelClass<HMM>, arg1: {
    as: string;
    foreignKey?: string;
    sourceKey?: string;
  }) => void;
  hasOne: <HOM extends $ModelName>(arg0: $ModelClass<HOM>, arg1: {
    as: string;
    constraints?: boolean;
    foreignKey?: string;
    sourceKey?: string;
  }) => void;
  hooks: () => void;
  name: M;
};

export type $ModelClasses = {
  Admin: $ModelClass<'Admin'>;
  AdminAccessToken: $ModelClass<'AdminAccessToken'>;
  AdminSocialUser: $ModelClass<'AdminSocialUser'>;
  Advertisement: $ModelClass<'Advertisement'>;
  Banner: $ModelClass<'Banner'>;
  BannerLocation: $ModelClass<'BannerLocation'>;
  Championship: $ModelClass<'Championship'>;
  ChampionshipAdmin: $ModelClass<'ChampionshipAdmin'>;
  ChampionshipAdminRequest: $ModelClass<'ChampionshipAdminRequest'>;
  ChampionshipDocument: $ModelClass<'ChampionshipDocument'>;
  ChampionshipRegatta: $ModelClass<'ChampionshipRegatta'>;
  ChampionshipResultTable: $ModelClass<'ChampionshipResultTable'>;
  ChampionshipResultTableEntry: $ModelClass<'ChampionshipResultTableEntry'>;
  ChampionshipResultTableRace: $ModelClass<'ChampionshipResultTableRace'>;
  ChampionshipResultTableRaceResult: $ModelClass<'ChampionshipResultTableRaceResult'>;
  ChampionshipSponsor: $ModelClass<'ChampionshipSponsor'>;
  ChampionshipSubscription: $ModelClass<'ChampionshipSubscription'>;
  Crewmember: $ModelClass<'Crewmember'>;
  CrewmemberAccessToken: $ModelClass<'CrewmemberAccessToken'>;
  CrewmemberPushToken: $ModelClass<'CrewmemberPushToken'>;
  CrewmemberRegattaNotification: $ModelClass<'CrewmemberRegattaNotification'>;
  CrewmemberSocialUser: $ModelClass<'CrewmemberSocialUser'>;
  CustomPage: $ModelClass<'CustomPage'>;
  Entry: $ModelClass<'Entry'>;
  EntryRating: $ModelClass<'EntryRating'>;
  Group: $ModelClass<'Group'>;
  Rating: $ModelClass<'Rating'>;
  Regatta: $ModelClass<'Regatta'>;
  RegattaAdmin: $ModelClass<'RegattaAdmin'>;
  RegattaAdminRequest: $ModelClass<'RegattaAdminRequest'>;
  RegattaBoatRent: $ModelClass<'RegattaBoatRent'>;
  RegattaCheck: $ModelClass<'RegattaCheck'>;
  RegattaContact: $ModelClass<'RegattaContact'>;
  RegattaCourse: $ModelClass<'RegattaCourse'>;
  RegattaCoursePoint: $ModelClass<'RegattaCoursePoint'>;
  RegattaCourseRace: $ModelClass<'RegattaCourseRace'>;
  RegattaDay: $ModelClass<'RegattaDay'>;
  RegattaDocument: $ModelClass<'RegattaDocument'>;
  RegattaEntry: $ModelClass<'RegattaEntry'>;
  RegattaEntryCheck: $ModelClass<'RegattaEntryCheck'>;
  RegattaEntryCrewmember: $ModelClass<'RegattaEntryCrewmember'>;
  RegattaEntryRating: $ModelClass<'RegattaEntryRating'>;
  RegattaEntryRequirement: $ModelClass<'RegattaEntryRequirement'>;
  RegattaEntryTrackPoint: $ModelClass<'RegattaEntryTrackPoint'>;
  RegattaGallery: $ModelClass<'RegattaGallery'>;
  RegattaGroup: $ModelClass<'RegattaGroup'>;
  RegattaLog: $ModelClass<'RegattaLog'>;
  RegattaMessage: $ModelClass<'RegattaMessage'>;
  RegattaNotification: $ModelClass<'RegattaNotification'>;
  RegattaPayment: $ModelClass<'RegattaPayment'>;
  RegattaPaymentDiscount: $ModelClass<'RegattaPaymentDiscount'>;
  RegattaProtest: $ModelClass<'RegattaProtest'>;
  RegattaProtestEnd: $ModelClass<'RegattaProtestEnd'>;
  RegattaRequirement: $ModelClass<'RegattaRequirement'>;
  RegattaResultDiploma: $ModelClass<'RegattaResultDiploma'>;
  RegattaResultOverall: $ModelClass<'RegattaResultOverall'>;
  RegattaResultOverallEntry: $ModelClass<'RegattaResultOverallEntry'>;
  RegattaResultOverallRegattaResultTable: $ModelClass<'RegattaResultOverallRegattaResultTable'>;
  RegattaResultTable: $ModelClass<'RegattaResultTable'>;
  RegattaResultTableEntry: $ModelClass<'RegattaResultTableEntry'>;
  RegattaResultTableRace: $ModelClass<'RegattaResultTableRace'>;
  RegattaResultTableRaceResult: $ModelClass<'RegattaResultTableRaceResult'>;
  RegattaSchedule: $ModelClass<'RegattaSchedule'>;
  RegattaSponsor: $ModelClass<'RegattaSponsor'>;
  RegattaSubscription: $ModelClass<'RegattaSubscription'>;
  RegattaTrackEvent: $ModelClass<'RegattaTrackEvent'>;
  RegattaTrackEventRegattaCourse: $ModelClass<'RegattaTrackEventRegattaCourse'>;
  Region: $ModelClass<'Region'>;
  RegionSeason: $ModelClass<'RegionSeason'>;
  RegionSeasonRegattaLocation: $ModelClass<'RegionSeasonRegattaLocation'>;
};

export type $Models = {
  Admin: $Model<'Admin'>;
  AdminAccessToken: $Model<'AdminAccessToken'>;
  AdminSocialUser: $Model<'AdminSocialUser'>;
  Advertisement: $Model<'Advertisement'>;
  Banner: $Model<'Banner'>;
  BannerLocation: $Model<'BannerLocation'>;
  Championship: $Model<'Championship'>;
  ChampionshipAdmin: $Model<'ChampionshipAdmin'>;
  ChampionshipAdminRequest: $Model<'ChampionshipAdminRequest'>;
  ChampionshipDocument: $Model<'ChampionshipDocument'>;
  ChampionshipRegatta: $Model<'ChampionshipRegatta'>;
  ChampionshipResultTable: $Model<'ChampionshipResultTable'>;
  ChampionshipResultTableEntry: $Model<'ChampionshipResultTableEntry'>;
  ChampionshipResultTableRace: $Model<'ChampionshipResultTableRace'>;
  ChampionshipResultTableRaceResult: $Model<'ChampionshipResultTableRaceResult'>;
  ChampionshipSponsor: $Model<'ChampionshipSponsor'>;
  ChampionshipSubscription: $Model<'ChampionshipSubscription'>;
  Crewmember: $Model<'Crewmember'>;
  CrewmemberAccessToken: $Model<'CrewmemberAccessToken'>;
  CrewmemberPushToken: $Model<'CrewmemberPushToken'>;
  CrewmemberRegattaNotification: $Model<'CrewmemberRegattaNotification'>;
  CrewmemberSocialUser: $Model<'CrewmemberSocialUser'>;
  CustomPage: $Model<'CustomPage'>;
  Entry: $Model<'Entry'>;
  EntryRating: $Model<'EntryRating'>;
  Group: $Model<'Group'>;
  Rating: $Model<'Rating'>;
  Regatta: $Model<'Regatta'>;
  RegattaAdmin: $Model<'RegattaAdmin'>;
  RegattaAdminRequest: $Model<'RegattaAdminRequest'>;
  RegattaBoatRent: $Model<'RegattaBoatRent'>;
  RegattaCheck: $Model<'RegattaCheck'>;
  RegattaContact: $Model<'RegattaContact'>;
  RegattaCourse: $Model<'RegattaCourse'>;
  RegattaCoursePoint: $Model<'RegattaCoursePoint'>;
  RegattaCourseRace: $Model<'RegattaCourseRace'>;
  RegattaDay: $Model<'RegattaDay'>;
  RegattaDocument: $Model<'RegattaDocument'>;
  RegattaEntry: $Model<'RegattaEntry'>;
  RegattaEntryCheck: $Model<'RegattaEntryCheck'>;
  RegattaEntryCrewmember: $Model<'RegattaEntryCrewmember'>;
  RegattaEntryRating: $Model<'RegattaEntryRating'>;
  RegattaEntryRequirement: $Model<'RegattaEntryRequirement'>;
  RegattaEntryTrackPoint: $Model<'RegattaEntryTrackPoint'>;
  RegattaGallery: $Model<'RegattaGallery'>;
  RegattaGroup: $Model<'RegattaGroup'>;
  RegattaLog: $Model<'RegattaLog'>;
  RegattaMessage: $Model<'RegattaMessage'>;
  RegattaNotification: $Model<'RegattaNotification'>;
  RegattaPayment: $Model<'RegattaPayment'>;
  RegattaPaymentDiscount: $Model<'RegattaPaymentDiscount'>;
  RegattaProtest: $Model<'RegattaProtest'>;
  RegattaProtestEnd: $Model<'RegattaProtestEnd'>;
  RegattaRequirement: $Model<'RegattaRequirement'>;
  RegattaResultDiploma: $Model<'RegattaResultDiploma'>;
  RegattaResultOverall: $Model<'RegattaResultOverall'>;
  RegattaResultOverallEntry: $Model<'RegattaResultOverallEntry'>;
  RegattaResultOverallRegattaResultTable: $Model<'RegattaResultOverallRegattaResultTable'>;
  RegattaResultTable: $Model<'RegattaResultTable'>;
  RegattaResultTableEntry: $Model<'RegattaResultTableEntry'>;
  RegattaResultTableRace: $Model<'RegattaResultTableRace'>;
  RegattaResultTableRaceResult: $Model<'RegattaResultTableRaceResult'>;
  RegattaSchedule: $Model<'RegattaSchedule'>;
  RegattaSponsor: $Model<'RegattaSponsor'>;
  RegattaSubscription: $Model<'RegattaSubscription'>;
  RegattaTrackEvent: $Model<'RegattaTrackEvent'>;
  RegattaTrackEventRegattaCourse: $Model<'RegattaTrackEventRegattaCourse'>;
  Region: $Model<'Region'>;
  RegionSeason: $Model<'RegionSeason'>;
  RegionSeasonRegattaLocation: $Model<'RegionSeasonRegattaLocation'>;
};

type $ModelShape<M extends $ModelName> = (
  Sequelize: Record<string, unknown>,
  stack: Record<string, unknown>
) => $ModelClass<M>;

export type $ModelShapes = {
  Admin: $ModelShape<'Admin'>;
  AdminAccessToken: $ModelShape<'AdminAccessToken'>;
  AdminSocialUser: $ModelShape<'AdminSocialUser'>;
  Advertisement: $ModelShape<'Advertisement'>;
  Banner: $ModelShape<'Banner'>;
  BannerLocation: $ModelShape<'BannerLocation'>;
  Championship: $ModelShape<'Championship'>;
  ChampionshipAdmin: $ModelShape<'ChampionshipAdmin'>;
  ChampionshipAdminRequest: $ModelShape<'ChampionshipAdminRequest'>;
  ChampionshipDocument: $ModelShape<'ChampionshipDocument'>;
  ChampionshipRegatta: $ModelShape<'ChampionshipRegatta'>;
  ChampionshipResultTable: $ModelShape<'ChampionshipResultTable'>;
  ChampionshipResultTableEntry: $ModelShape<'ChampionshipResultTableEntry'>;
  ChampionshipResultTableRace: $ModelShape<'ChampionshipResultTableRace'>;
  ChampionshipResultTableRaceResult: $ModelShape<'ChampionshipResultTableRaceResult'>;
  ChampionshipSponsor: $ModelShape<'ChampionshipSponsor'>;
  ChampionshipSubscription: $ModelShape<'ChampionshipSubscription'>;
  Crewmember: $ModelShape<'Crewmember'>;
  CrewmemberAccessToken: $ModelShape<'CrewmemberAccessToken'>;
  CrewmemberPushToken: $ModelShape<'CrewmemberPushToken'>;
  CrewmemberRegattaNotification: $ModelShape<'CrewmemberRegattaNotification'>;
  CrewmemberSocialUser: $ModelShape<'CrewmemberSocialUser'>;
  CustomPage: $ModelShape<'CustomPage'>;
  Entry: $ModelShape<'Entry'>;
  EntryRating: $ModelShape<'EntryRating'>;
  Group: $ModelShape<'Group'>;
  Rating: $ModelShape<'Rating'>;
  Regatta: $ModelShape<'Regatta'>;
  RegattaAdmin: $ModelShape<'RegattaAdmin'>;
  RegattaAdminRequest: $ModelShape<'RegattaAdminRequest'>;
  RegattaBoatRent: $ModelShape<'RegattaBoatRent'>;
  RegattaCheck: $ModelShape<'RegattaCheck'>;
  RegattaContact: $ModelShape<'RegattaContact'>;
  RegattaCourse: $ModelShape<'RegattaCourse'>;
  RegattaCoursePoint: $ModelShape<'RegattaCoursePoint'>;
  RegattaCourseRace: $ModelShape<'RegattaCourseRace'>;
  RegattaDay: $ModelShape<'RegattaDay'>;
  RegattaDocument: $ModelShape<'RegattaDocument'>;
  RegattaEntry: $ModelShape<'RegattaEntry'>;
  RegattaEntryCheck: $ModelShape<'RegattaEntryCheck'>;
  RegattaEntryCrewmember: $ModelShape<'RegattaEntryCrewmember'>;
  RegattaEntryRating: $ModelShape<'RegattaEntryRating'>;
  RegattaEntryRequirement: $ModelShape<'RegattaEntryRequirement'>;
  RegattaEntryTrackPoint: $ModelShape<'RegattaEntryTrackPoint'>;
  RegattaGallery: $ModelShape<'RegattaGallery'>;
  RegattaGroup: $ModelShape<'RegattaGroup'>;
  RegattaLog: $ModelShape<'RegattaLog'>;
  RegattaMessage: $ModelShape<'RegattaMessage'>;
  RegattaNotification: $ModelShape<'RegattaNotification'>;
  RegattaPayment: $ModelShape<'RegattaPayment'>;
  RegattaPaymentDiscount: $ModelShape<'RegattaPaymentDiscount'>;
  RegattaProtest: $ModelShape<'RegattaProtest'>;
  RegattaProtestEnd: $ModelShape<'RegattaProtestEnd'>;
  RegattaRequirement: $ModelShape<'RegattaRequirement'>;
  RegattaResultDiploma: $ModelShape<'RegattaResultDiploma'>;
  RegattaResultOverall: $ModelShape<'RegattaResultOverall'>;
  RegattaResultOverallEntry: $ModelShape<'RegattaResultOverallEntry'>;
  RegattaResultOverallRegattaResultTable: $ModelShape<'RegattaResultOverallRegattaResultTable'>;
  RegattaResultTable: $ModelShape<'RegattaResultTable'>;
  RegattaResultTableEntry: $ModelShape<'RegattaResultTableEntry'>;
  RegattaResultTableRace: $ModelShape<'RegattaResultTableRace'>;
  RegattaResultTableRaceResult: $ModelShape<'RegattaResultTableRaceResult'>;
  RegattaSchedule: $ModelShape<'RegattaSchedule'>;
  RegattaSponsor: $ModelShape<'RegattaSponsor'>;
  RegattaSubscription: $ModelShape<'RegattaSubscription'>;
  RegattaTrackEvent: $ModelShape<'RegattaTrackEvent'>;
  RegattaTrackEventRegattaCourse: $ModelShape<'RegattaTrackEventRegattaCourse'>;
  Region: $ModelShape<'Region'>;
  RegionSeason: $ModelShape<'RegionSeason'>;
  RegionSeasonRegattaLocation: $ModelShape<'RegionSeasonRegattaLocation'>;
};

export const modelShapes: $ModelShapes = {
  Admin,
  AdminAccessToken,
  AdminSocialUser,
  Advertisement,
  Banner,
  BannerLocation,
  Championship,
  ChampionshipAdmin,
  ChampionshipAdminRequest,
  ChampionshipDocument,
  ChampionshipRegatta,
  ChampionshipResultTable,
  ChampionshipResultTableEntry,
  ChampionshipResultTableRace,
  ChampionshipResultTableRaceResult,
  ChampionshipSponsor,
  ChampionshipSubscription,
  Crewmember,
  CrewmemberAccessToken,
  CrewmemberPushToken,
  CrewmemberRegattaNotification,
  CrewmemberSocialUser,
  CustomPage,
  Entry,
  EntryRating,
  Group,
  Rating,
  Regatta,
  RegattaAdmin,
  RegattaAdminRequest,
  RegattaBoatRent,
  RegattaCheck,
  RegattaContact,
  RegattaCourse,
  RegattaCoursePoint,
  RegattaCourseRace,
  RegattaDay,
  RegattaDocument,
  RegattaEntry,
  RegattaEntryCheck,
  RegattaEntryCrewmember,
  RegattaEntryRating,
  RegattaEntryRequirement,
  RegattaEntryTrackPoint,
  RegattaGallery,
  RegattaGroup,
  RegattaLog,
  RegattaMessage,
  RegattaNotification,
  RegattaPayment,
  RegattaPaymentDiscount,
  RegattaProtest,
  RegattaProtestEnd,
  RegattaRequirement,
  RegattaResultDiploma,
  RegattaResultOverall,
  RegattaResultOverallEntry,
  RegattaResultOverallRegattaResultTable,
  RegattaResultTable,
  RegattaResultTableEntry,
  RegattaResultTableRace,
  RegattaResultTableRaceResult,
  RegattaSchedule,
  RegattaSponsor,
  RegattaSubscription,
  RegattaTrackEvent,
  RegattaTrackEventRegattaCourse,
  Region,
  RegionSeason,
  RegionSeasonRegattaLocation,
};
